// CLASSES
import AppConfig from "@classes/AppConfig";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}
	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	/**
	 * At least AML origin option needs to be checked
	 */
	if (!optionsListValueSelected(fields.aml_origin_options)) {
		return false;
	}

	/**
	 * At least one Syfte option needs to be checked
	 */
	if (!optionsListValueSelected(fields.checkbox_customer_kyc_purpose)) {
		return false;
	}

	/**
	 * At least one Size of deposits option needs to be checked
	 */
	if (!optionsListValueSelected(fields.radio_aml_deposit_amt)) {
		return false;
	}

	/**
	 * At least one deposit frequency option needs to be checked
	 */
	if (!optionsListValueSelected(fields.radio_aml_deposit)) {
		return false;
	}

	/**
	 * At least one Source option needs to be checked
	 */
	if (!optionsListValueSelected(fields.checkbox_customer_kyc_deposit)) {
		return false;
	}

	/**
	 * Customer needs to be owner of funds, otherwise no account can be opened
	 */
	if (!fields.checkbox_aml_own_money.options[1].checked) {
		return false;
	}

	if (fields.checkbox_customer_kyc_empl.index !== -1) {
		if (fields.checkbox_customer_kyc_empl.index === 7 && fields.customer_kyc_empl_other.length === 0) {
			return false;
		}
	}
	else {
		return false;
	}

	/**
	 * Options List values for Erfernhetsbakgrund, all need to be selected
	 */
	if (fields.radio_kyc_knowledge_aktier.index === -1 ||
		fields.radio_kyc_transactions_aktier.index === -1 ||
		fields.radio_aml_transaction_size_aktier.index === -1 ||
		fields.radio_kyc_knowledge_fonder.index === -1 ||
		fields.radio_kyc_transactions_fonder.index === -1 ||
		fields.radio_aml_transaction_size_fonder.index === -1 ||
		fields.radio_kyc_knowledge_isk.index === -1 ||
		fields.radio_kyc_transactions_isk.index === -1 ||
		fields.radio_aml_transaction_size_isk.index === -1
	) {
		return false;
	}

	return true;
}


function optionsListValueSelected(optionsList) {
	const options = optionsList.options;
	for (let i = 0; i < options.length; i++) {
		if (options[i].checked) {
			return true;
		}
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/fair-gds-oppna/Fields/Fields.fulfillment.js